import "../styles/App.css";

const ShlokCard = ({shlok}) =>{
    return (
        <div className="shlok-card">
            <pre className="shlok">{shlok}</pre>
        </div>
    );
}
export default ShlokCard;